export default __webpack_public_path__ + "1f08fd3bd6f5b2f131342f737a6842d5.png";